import { TellescopeCustomFilterProps } from "../types";
import { levenshteinDistance } from "@tellescope/utils";

export interface HandleCustomFilterArgs<T> extends TellescopeCustomFilterProps<T> {
  fallbackOptions: T[];
  debouncedSearchQuery: string;
  getStrings: (option: T) => string[];
}

// TODO(plan:enduser-forms-part-4): open question #6 — the report lists this as exported but never
//   invoked by any field in Part 4's scope. It is called by `AllergiesField` and `ConditionsField`
//   (both Part 6), and by nothing in this part. Confirm and close as `[INTENDED]` — no Part 4 field
//   should route through it — or note if a choice field ought to.
export const handleCustomFilter = <T>({
  filterOptions,
  customFilter,
  fallbackOptions,
  debouncedSearchQuery,
  getStrings,
}: HandleCustomFilterArgs<T>) => {
  if (customFilter && filterOptions === undefined) {
    return customFilter(debouncedSearchQuery, fallbackOptions);
  } else if (customFilter) {
    return customFilter(debouncedSearchQuery, filterOptions ?? []);
  } else if (filterOptions === undefined) {
    return fallbackOptions;
  } else {
    return filterOptions.sort((a, b) => {
      const aStrings = getStrings(a).map((str) => str.toLowerCase());
      const bStrings = getStrings(b).map((str) => str.toLowerCase());
      const search = debouncedSearchQuery.toLowerCase();
      const aDistances = aStrings.map((str) => levenshteinDistance(str, search));
      const bDistances = bStrings.map((str) => levenshteinDistance(str, search));
      const aMin = Math.min(...aDistances);
      const bMin = Math.min(...bDistances);
      return bMin - aMin;
    });
  }
};
